import axios from "axios";
import { getAuthHeader } from "../../../utils/authHeader";

// Cancel an in-wizard caption review right away (the held draft posts are
// removed server-side) instead of leaving them for the 60-minute reaper.
// Best-effort: the reaper still backstops a failed call, so this never throws.
export async function cancelZapcapReview(taskId: string): Promise<boolean> {
    try {
        const headers = await getAuthHeader();
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        await axios.post(
            `${backendUrl}/post/zapcap-review/${taskId}/cancel`,
            {},
            { headers }
        );
        return true;
    } catch {
        return false;
    }
}
